import { toast } from "sonner";

export default function useHandleErrors() {

    const handleErrors = (response: any) => {
        if (!response.success) {
            if (response.data?.errors)
            {
                response.data.errors?.forEach((error: any) => {
                    if(error.warning) toast.warning(error.message)
                    else toast.error(error.message);
                });
            } else {
                if(response.warning) {
                    const warningMessage = JSON.parse(response.message);
                    
                    warningMessage?.forEach((warning: string) => {
                        toast.warning(warning);
                    });
                }
                else toast.error(response.message);
            }
        }
    }

    return { handleErrors };
}